import React from "react";

const ROWS = 6;

const DocumentListSkeleton = () => (
  <div className="space-y-3" aria-busy="true" aria-label="Carregando documentos">
    <div className="hidden md:block rounded-xl border border-border overflow-hidden">
      <div className="h-10 bg-muted/50 animate-pulse" />
      {Array.from({ length: ROWS }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-4 px-4 py-3 border-t border-border"
        >
          <div className="h-4 flex-1 max-w-[200px] bg-muted animate-pulse rounded" />
          <div className="h-4 w-24 bg-muted animate-pulse rounded hidden lg:block" />
          <div className="h-6 w-20 bg-muted animate-pulse rounded-full" />
          <div className="h-8 w-28 bg-muted animate-pulse rounded ml-auto" />
        </div>
      ))}
    </div>
    <div className="md:hidden space-y-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl border border-border p-4 space-y-3 animate-pulse"
        >
          <div className="h-4 w-3/4 bg-muted rounded" />
          <div className="h-3 w-1/2 bg-muted rounded" />
          <div className="flex gap-2 pt-2">
            <div className="h-9 flex-1 bg-muted rounded" />
            <div className="h-9 w-9 bg-muted rounded" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DocumentListSkeleton;
